import React from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Button} from "primereact/button";
import {Badge} from "primereact/badge";

const CandidateWorkexperienceListComponent = (props) => {

  const history = useHistory();
  const {id} = useParams();
  const workexperiences = props.workexperiences || [];

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-mr-2"
                  tooltip={props.t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    history.push(`/recruitment/candidate/read/${id}?update=candidate-work-experience&candidateWorkexperienceId=${rowData.id}&candidateId=${id}`)
                  }}/>
        }
      </React.Fragment>
    );
  }

  const renderCard = (rowData) => (
    <div key={rowData.id} className="p-card p-shadow-2 p-mb-3" style={{overflow: 'hidden'}}>
      <div className="p-p-3 p-d-flex p-jc-between p-ai-start p-flex-wrap" style={{gap: '1rem'}}>
        <div className="p-d-flex p-flex-column" style={{gap: '0.85rem', flex: '1 1 240px'}}>
          <div className="p-d-flex p-ai-center p-flex-wrap" style={{gap: '0.5rem'}}>
            <span style={{display: 'inline-block'}}>
              <Badge value={props.t('workExperience')} severity="info" rounded />
            </span>
            <span className="p-text-bold">{rowData?.company_name || props.t('noCompanyProvided')}</span>
          </div>
          <div className="p-text-600">{rowData?.job || props.t('noJobProvided')}</div>
          <div className="p-text-secondary">
            {props.t('graduation')}: {rowData?.end_date ? window.App.formatDateValue(rowData?.end_date || '') : <span style={{color: '#a8a8a8'}}>? </span>}
          </div>
        </div>
        <div className="p-d-flex p-ai-start">
          {actionBodyTemplate(rowData)}
        </div>
      </div>
    </div>
  )

  return (
    <>
      <div className="p-d-flex p-flex-column">
        {workexperiences.length > 0 ? workexperiences.map(renderCard) : (
          <div className="p-p-3 p-text-secondary p-text-center p-border-1" style={{borderStyle: 'dashed', borderRadius: '12px'}}>
            {props.t('noResults')}
          </div>
        )}
      </div>
    </>
  )
}
export default withTranslation('common')(CandidateWorkexperienceListComponent);
